export default "__VITE_ASSET__CcdM8Kyl__"